import { AxiosResponse } from "axios";
import api from "./api";

interface AuthResponse {
  success: string;
  data: {
    authenticate_status: string;
    role: string;
    expired_at: string;
  };
}
interface AuthRequest {
  email: string;
  password: string;
}
class UserApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async login(data: AuthRequest): Promise<AxiosResponse> {
    return this.getHttp().post<AuthResponse>("/login", data);
  }

  async logout(): Promise<AxiosResponse> {
    return this.getHttp().get<AuthResponse>("/logout");
  }
  async me(): Promise<any> {
    const response = await this.getHttp().get<any>("/me", {
      data: {
        notLoading: true,
      },
    });

    return response.data.data;
  }
}
export default new UserApi();
